import {callAPI} from '@/store/utils';

export const companyMixin = {
  methods: {
    async switchCompany(cid, route, target) {
      const id = Array.isArray(cid) ? cid[cid.length - 1] : cid;
      const companyId = localStorage.getItem('FYGR_COMPANY');
      if (companyId === id) {
        return;
      }
      localStorage.setItem('FYGR_COMPANY', id);
      const res = await callAPI('POST', 'getBanksAndAccountsList', {
        companyId: id,
      });
      if (!target) {
        if (
          res &&
          !res.error &&
          res.result.banks &&
          res.result.banks.length === 0
        ) {
          window.open('/onboarding', '_self');
          return;
        }
        if (
          String(route) === 'console' ||
          String(route) === 'onboarding-welcome'
        ) {
          window.open('/dashboard', '_self');
          return;
        }
        window.location.reload();
      } else {
        window.open(`/${target}`, '_self');
      }
    },
    checkSiret(siret) {
      /* eslint use-isnan: "error" */
      return !(siret.length !== 14 || siret === '');
    },
  },
  computed: {
    listOfCompanies() {
      if (this.isCompanyCpa || this.isCpaUser(this.activeUser)) {
        const generalList = [];
        const transformed = this.displayedCompanies(this.companyList).reduce(
          (acc, el) => {
            if (el[1][3]) {
              acc.name = el[1][0] ? el[1][0] : ' ';
              /* eslint-disable */
              acc.id = el[0];
              /* eslint-enable */
            } else if (el[1][2]) {
              acc.list.push({
                id: el[0],
                name: el[1][0] ? el[1][0] : ' ',
              });
            } else {
              generalList.push({
                id: el[0],
                name: el[1][0] ? el[1][0] : ' ',
                companyCustom: true,
              });
            }
            return acc;
          },
          {list: [], companyCustom: true},
        );
        if (this.mobile) {
          return [
            ...generalList,
            {id: transformed.id, name: transformed.name, companyCustom: true},
            ...transformed.list,
          ];
        }
        return [...generalList, transformed];
      }
      return this.displayedCompanies(this.companyList)
        .filter((c) => !c[1][0] || c[1][0].includes(this.searchCompany))
        .map((c) => ({
          id: c[0],
          name: c[1][0] ? c[1][0] : ' ',
        }));
    },
  },
};

export default {companyMixin};
